export default "__VITE_ASSET__eT3udAvK__"